module.exports = __webpack_public_path__ + "static/media/fi.8c63a9af.svg";